module.exports = __webpack_public_path__ + "static/img/pro1-2.f741f60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro1-2.png
// module id = mKuN
// module chunks = 0